import { defineStore } from 'pinia'
import type { ISbStoryData } from 'storyblok-js-client'
import type { WizPageBlok } from '~/types/storyblok'

export const useStoryData = defineStore('story', () => {
  const storyData = ref<ISbStoryData<WizPageBlok> | null>(null)

  return { storyData }
})
